import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

const getSelected = state => state.UserOrgSiteReducer.selected;

function* createReportSaga({ payload }) {
    try {
        const selected = yield select(getSelected);
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.CREATE_REPORT,
            data: {
                id: payload.id,
                site: payload.site,
                department: payload.department || undefined,
                type: payload.type,
                name: payload.name,
                audit: payload.audit,
                organization: selected.org,
                date_from: payload.date_from || undefined,
                date_to: payload.date_to || undefined,
                filter: payload.filter || undefined,
                org_wide: payload.type === 'device' ? true : undefined,
            }
        });
        if (apiResponse) {
            // SUCCESS
            yield put({ type: ActionTypeConstants.CREATE_REPORT_SUCCESS });
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "Report created!",
                    color: "success"
                }
            });
            yield put({ type: ActionTypeConstants.LOAD_REPORTS });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "Creating report failed!",
                    color: "danger"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        }

    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "Error - Report not created!",
                color: "danger"
            }
        });
        yield delay(10000)
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.CREATE_REPORT, createReportSaga);
}
